import { useWorkspacesQuery as useWorkspacesQueryCodegen } from '../../pages/home-page/components/your-workspaces/YourWorkspaces.codegen'

/**
 * used in campaigns and navigation
 */
export function useCachedWorkspacesQuery() {
  return useWorkspacesQueryCodegen({
    fetchPolicy: 'cache-first'
  })
}
